// import important dependencies
import 'bootstrap';
import lozad from 'lozad';

import jQuery from 'jquery';

window.$ = jQuery;

import './old/core/search';
import './old/components/carousel.js';
import './old/components/draggable.js';

window.packetaCallback = (callback) => {
    console.log(callback);
    $.ajax({
        url: '/kosik/change-shippment',
        type: 'POST',
        headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
        },
        data: {
            'delivery-method': $('.shipment-method:checked').val(),
            branch_id: callback.id,
            branch_address: callback.street,
            branch_city: callback.city,
            branch_zip: callback.zip,
        },
        success: function (data) {
            $('#cartShowForm').html(data.html);
        },
    });
};

$('#btnFilter').on('click', () => {
    let sidebar = $('.sidebar');
    sidebar.removeClass('d-none');
    sidebar.addClass('show');
    $('body').append('<div class="modal-backdrop fade show d-lg-none"></div>');
});

$('.show-more').on('click', function () {
    $(this).hide();
    let target = $(this).data('target');
    $(target).find('.custom-control').removeClass('d-none');
});

$('#closeSidebar').on('click', function (event) {
    $('.sidebar').addClass('d-none');
    $('.sidebar').removeClass('show');
    $('.modal-backdrop').remove();
});

$(window).on('load resize', function () {
    let container_width = $('#mainNav').find('.container').innerWidth();
    $('#mainNav .dropdown-menu').css('min-width', container_width - 60);
    $('#mainNav .dropdown-menu').css('left', 30);
});

$(function () {
    $('.navbar-toggler').click(function () {
        $(this).find('.navbar-toggler-icon').toggleClass('toggled');
    });
});

$(window).on('load resize', function () {
    if ($(window).width() < 992) {
        $('#secondaryNav .dropdown-toggle').on('click', function (event) {
            event.preventDefault();
        });
    }
});

$(function () {
    $('#prevSecondaryNav').on('click', function () {
        $('#secondaryNavInner').animate(
            {
                scrollLeft: '-=150px',
            },
            'slow',
        );
    });

    $('#nextSecondaryNav').on('click', function () {
        $('#secondaryNavInner').animate(
            {
                scrollLeft: '+=150px',
            },
            'slow',
        );
    });
});

$(document).ready(function () {
    $('.js-dropshipping-switch label').on('click', function () {
        $('#dropshippingAddress').toggleClass('d-none');
    });

    $('.js-nav-opener').on('click', function () {
        $('.nav').slideToggle('medium', function () {
            if ($(this).is(':visible')) $(this).css('display', 'flex');
        });
    });

    $('#showYtbVideo').on('click', function (e) {
        $('#myTab a[href="#ytb"]').tab('show');

        $([document.documentElement, document.body]).animate(
            {
                scrollTop: $('#ytb-tab').offset().top - 50,
            },
            1000,
        );
    });

    $('.newsletter-form input[type="checkbox"]').on('click', function () {
        $(this).closest('form').find('button').prop('disabled', !$(this).is(':checked'))
    })
});

$(function () {
    const observer = lozad(); // lazy loads elements with default selector as '.lozad'
    observer.observe();
});

$(document).ready(function () {
    $('#customFile').on('change', (event) => {
        const file = event.target.files[0];

        $('#avatar').attr('src', URL.createObjectURL(file));
    });
});

/* ZRUSIT OBJEDNAVKU */
$('button.cancel-order').on('click', (e) => {
    const ID = e.target.dataset.orderid;

    if (window.confirm('Naozaj zrušiť objednávku?')) {
        const API_TOKEN = $('meta[name="api-token"]').attr('content');

        $.ajax({
            url: '/order/cancel/' + ID,
            type: 'POST',
            headers: {
                Authorization: 'Bearer ' + API_TOKEN,
                'X-Requested-With': 'XMLHttpRequest',
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
            },
            data: {
                id: ID,
            },
            success: function (result) {
                if (result.status) {
                    $('button.cancel-order[data-orderid="' + ID + '"]').remove();
                    $('#status-' + ID).text(result.text);
                }
            },
            error: function (error) {
                alert('Vyskytla sa chyba, skúste neskôr prosím.');
            },
        });
    }
});

// mobile classic menu sidebar
$('body').on('click', '.mobile-classic-sidebar #close-mobile-classic-sidebar', () => {
    $('.mobile-classic-sidebar').css({
        left: '-100%',
    });
    $('.overlay').remove();
});

$('body').on('click', '.overlay', () => {
    $('.mobile-classic-sidebar').css({
        left: '-100%',
    });
    $('.overlay').remove();
});

$('body').on('click', 'header #open-mobile-classic-sidebar', () => {
    $('.mobile-classic-sidebar').css({
        left: '0',
    });
    $('body').append(`<div class="overlay"></div>`);
});
